module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Calendar_16"],"path":[{"$":{"d":"M13,1V0H10V1H6V0H3V1H1V15H15V1ZM11,1h1V3H11ZM4,1H5V3H4ZM14,14H2V5H14ZM6,9H4V7H6ZM9,9H7V7H9Zm3,0H10V7h2ZM9,12H7V10H9ZM6,12H4V10H6Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Calendar_16.svg
// module id = Bama
// module chunks = 1